module.exports = __webpack_public_path__ + "static/img/anxun11.2da001bc.png";